module.exports = __webpack_public_path__ + "img/section_01.c29d0a4c.png";